import type { GetInstructorsUnapprovedResult, UnapprovedInstructor } from '@features/instructors/api/get-instructors-unapproved/getInstructorsUnapproved.types';
import type {
  PostInstructorsRequestsBatchRequest,
  PostInstructorsRequestsBatchRequestItem,
} from '@features/instructors/api/post-instructors-requests-batch/postInstructorsRequestsBatch.types';
import type { InstructorSection } from '@features/instructors/contexts/manage-instructors-selection/ManageInstructorsSelectionContext.types';

function buildSectionItems(
  sectionInstructors: UnapprovedInstructor[],
  selectedIds: Set<string>
): PostInstructorsRequestsBatchRequestItem[] {
  return sectionInstructors
    .filter(instructor => selectedIds.has(instructor.instructorId))
    .map(instructor => ({
      instructorId: instructor.instructorId,
      trainingCenterName: instructor.primaryTrainingCenter.name,
      programs: instructor.programs.map(program => ({
        id: program.id,
        authorizationId: program.authorizationId,
      })),
    }));
}

export function buildApproveInstructorsRequest(
  selectedIds: Record<InstructorSection, Set<string>>,
  data: GetInstructorsUnapprovedResult | undefined
): PostInstructorsRequestsBatchRequest {
  if (!data) {
    return { groundSchool: [], simulator: [], simCheck: [] };
  }

  return {
    groundSchool: buildSectionItems(data.groundSchool, selectedIds.groundSchool),
    simulator: buildSectionItems(data.simulator, selectedIds.simulator),
    simCheck: buildSectionItems(data.simCheck, selectedIds.simCheck),
  };
}
